import { Theme } from '@mui/material';
import { BACKDROP_STYLE } from '../../../config/styles';

export function backdrop(theme: Theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: BACKDROP_STYLE,
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
